import { useState } from 'react';
import { InitialCausalityFilters } from './filters';
import { InitialCausalityList } from './list';
import { LayoutModule } from '../../../layout/modules';
import { INITIAL_CAUSALITY_NEW } from '../../../../routes/paths';
import { InitialCausalityFilter } from '../../../../shared/types/typifications/initialCausality';
import { isOnlyViewProfile } from '../../../../shared/types/profiles';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';

export const InitialCausality = () => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const [filters, setFilters] = useState<InitialCausalityFilter>();

    return (
        <>
            <LayoutModule
                title="Búsqueda de causalidad inicial"
                showTitle
                {...(!isOnlyViewProfile(type) && {
                    createPath: INITIAL_CAUSALITY_NEW,
                })}
            >
                <InitialCausalityFilters
                    onFilter={(filters) => setFilters(filters)}
                />
            </LayoutModule>
            <InitialCausalityList filters={filters} />
        </>
    );
};
